import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateLoadType, UpdateLoadType} from "../../types/api/guide/loadType.types";


export const loadTypeService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.loadType.getAll),

    create: (loadType: CreateLoadType) =>
        apiCall.post(apiUrls.guide.loadType.create, loadType),

    update: (id: string, loadType: UpdateLoadType) =>
        apiCall.put(apiUrls.guide.loadType.update(id), loadType),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.loadType.delete(id)),

    getById: (id: string) =>
        apiCall.get(apiUrls.guide.loadType.getById(id))
}